var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ColorTextBtn',{attrs:{"size":"mini"},on:{"click":function($event){return _vm.downExpressWaybillFile(_vm.data)}}},[_vm._v("下载")])}
var staticRenderFns = []

export { render, staticRenderFns }